// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/sfc.scss
// module id = 720
// module chunks = 0